import { trainingZoneColor } from '../../utils/trainingZones';
import { workoutDisplayDigits as displayDigits } from '../../utils/workoutNumberFormat';
import { formatZoneTime } from '../../utils/secToHMS';

interface Zone { zone?: number; time_in_seconds: number; percent_in_zone?: number }
/** Independent zone distribution: percentages use recorded time, not bar-relative maxima. */
export function WorkoutZoneDistribution({ title, zones, kind }: { title: string; zones: Zone[]; kind: 'heart' | 'power' }) {
  if (!zones.length) return null;
  const rows = zones.map((zone, index) => ({ ...zone, number: zone.zone ?? index + 1, seconds: Math.max(0, Number(zone.time_in_seconds) || 0) }));
  const total = rows.reduce((sum, zone) => sum + zone.seconds, 0);
  return <section className={`workout-zone-card workout-zone-card--${kind}`} aria-label={title}>
    <header><h3>{title}</h3><span className="ltr-island">{displayDigits(formatZoneTime(total))}</span></header>
    <div className="workout-zone-card__rows" style={{ marginTop: 12 }}>
      {[...rows].sort((a, b) => b.number - a.number).map((zone, index) => {
        const percent = typeof zone.percent_in_zone === 'number' && Number.isFinite(zone.percent_in_zone) ? Math.max(0, Math.min(100, zone.percent_in_zone)) : total > 0 ? zone.seconds / total * 100 : 0;
        return <div className="workout-zone-card__row" key={`${zone.number}-${index}`}>
          <strong dir="ltr">Z{displayDigits(String(zone.number))}</strong>
          <div className="workout-zone-card__track" aria-hidden="true"><span style={{ width: `${percent}%`, background: trainingZoneColor(zone.number) }} /></div>
          <span className="workout-zone-card__percent" dir="ltr">{displayDigits(`${Math.round(percent)}%`)}</span>
          <span className="workout-zone-card__time" dir="ltr">{displayDigits(formatZoneTime(zone.seconds))}</span>
        </div>;
      })}
    </div>
  </section>;
}
